import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type PreviewPanelStoreState = {
  isPreviewPanelOpen: boolean
  selectedItemId?: number
}

export type PreviewPanelStoreActions = {
  setIsPreviewPanelOpen(isPreviewPanelOpen: boolean): void
  setSelectedItemId(itemId?: number): void
  reset(): void
}

export const usePreviewPanelStore = create<
  PreviewPanelStoreState & PreviewPanelStoreActions
>()(
  persist(
    set => ({
      isPreviewPanelOpen: false,
      setIsPreviewPanelOpen: isPreviewPanelOpen =>
        set(() => ({ isPreviewPanelOpen })),
      setSelectedItemId: selectedItemId => set(() => ({ selectedItemId })),
      reset: () => set(() => ({ selectedItemId: undefined }))
    }),
    {
      name: 'preview-panel-storage',
      partialize: ({ isPreviewPanelOpen }) => ({ isPreviewPanelOpen })
    }
  )
)
